export enum YandexLanguageCode {
  ru = 'ru_RU',
  en = 'en_US',
  uk = 'uk_UA',
  tr = 'tr_TR',
}
